module.exports = __webpack_public_path__ + "img/img_safety_img3.bd57f6a7.png";